export const EXCMDEVICETYPE_SHOW_RESET = 'EXCMDEVICETYPE_SHOW_RESET'
export const EXCMDEVICETYPE_SHOW_SET_ERROR = 'EXCMDEVICETYPE_SHOW_SET_ERROR'
export const EXCMDEVICETYPE_SHOW_SET_RETRIEVED = 'EXCMDEVICETYPE_SHOW_SET_RETRIEVED'
export const EXCMDEVICETYPE_SHOW_TOGGLE_LOADING = 'EXCMDEVICETYPE_SHOW_TOGGLE_LOADING'
